exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/promotions.js-WebpackMultiOutput";